import * as React from 'react';

import { FieldError } from 'react-hook-form';

export interface IErrorMessageProps {
  error: FieldError;
  label: string;
}

export const ErrorMessage = ({ error, label }: IErrorMessageProps) => (
  <>
    {error ? (
      <>
        <div className='alert alert-danger'>
          {error.type === 'required' ? <div>{label} is required</div> : <div>{error.message}</div>}
        </div>
      </>
    ) : (
      ''
    )}
  </>
);
